import { render, staticRenderFns } from "./DialogValue.vue?vue&type=template&id=15a79eed"
import script from "./DialogValue.vue?vue&type=script&lang=js"
export * from "./DialogValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports